// src/pages/LoggedOut.js
import { Link } from "react-router-dom";
import "./Login.css";

export default function LoggedOut() {
  return (
    <div className="login-page">
      <div className="login-overlay"></div>

      <div className="login-container">
        <h2 style={{ textAlign: "center" }}>You are now logged out</h2>

        <p
          style={{
            marginTop: "10px",
            marginBottom: "20px",
            color: "#ccc",
            textAlign: "center",   // ✅ CENTERED
          }}
        >
          Thanks for visiting. Come back soon!
        </p>

        <Link
          to="/"
          className="login-register-link"
          style={{ display: "block", textAlign: "center" }} // also centered
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
